import { render, staticRenderFns } from "./MainBg.vue?vue&type=template&id=fb1d0da6&"
import script from "./MainBg.vue?vue&type=script&lang=js&"
export * from "./MainBg.vue?vue&type=script&lang=js&"
import style0 from "./MainBg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports